import SingleAlert from "./singleAlert";
import React, { useState } from "react";
import { Droppable } from "react-beautiful-dnd";

const SingleTask = ({
  ind,
  task,
  setShowMemberBox,
  setActiveTask,
  setSelectedAssignees,
  removeTaskAssignee,
}) => {
  const [hover, setHover] = useState(false);
  const [isAddAssignee, setIsAddAssignee] = useState(false);
  const color = ind % 2 === 0 ? "#00246A" : "#95A7C6";
  return (
    <div style={{ position: "relative" }}>
      <Droppable droppableId={`${task?.taskid}`} key={`droppable-${ind}`}>
        {(provided, snapshot) => {
          return (
            <div
              className="team-single-work-line-relative"
              {...provided.droppableProps}
              ref={provided.innerRef}
              key={`droppable-div-${ind}`}
              onMouseLeave={() => {
                setHover(false);
                setIsAddAssignee(false);
              }}
            >
              {isAddAssignee && (
                <div
                  className="frc cursor-pointer"
                  style={{
                    position: "absolute",
                    bottom: "100%",
                    left: task?.left,
                    gap: "0.5rem",
                  }}
                  onClick={() => {
                    setActiveTask(task?.taskid);
                    setSelectedAssignees([
                      ...task?.assignees,
                      ...task?.teamassignees,
                    ]);
                    setShowMemberBox(true);
                  }}
                >
                  <div className="team-add-assignee-plus-div">+</div>
                  <p className="team-add-assignee-text">Assign team</p>
                </div>
              )}
              <div
                className="task-line"
                style={{
                  width: task?.width || "20%",
                  left: task?.left || "12%",
                  display: task?.display || "flex",
                  backgroundColor: color,
                }}
                onMouseEnter={() => setIsAddAssignee(true)}
                onContextMenu={(e) => {
                  e.preventDefault();
                  setHover(true);
                }}
                onClick={(e) => {
                  if (e.button === 0) {
                    setActiveTask(task?.taskid);
                    setSelectedAssignees([
                      ...task?.assignees,
                      ...task?.teamassignees,
                    ]);
                    setShowMemberBox(true);
                    return;
                  }
                }}
              >
                {[
                  ...task?.assignees,
                  ...task?.teamassignees,
                  ...task?.equipment,
                ]?.map((employee, ind) => {
                  return (
                    <div
                      className="task-line-asignee-div"
                      key={ind}
                      onClick={() => {
                        if (employee?.notavailable?.length === 0) return;
                        removeTaskAssignee(task?.taskid, employee?.assigneeid);
                      }}
                    >
                      {employee?.imageurl ? (
                        <img
                          alt=""
                          className="task-line-assignees"
                          style={{ marginLeft: "0", borderColor: "#00246a" }}
                          src={employee?.imageurl}
                        />
                      ) : (
                        <div
                          className="team-member-abv"
                          style={{
                            width: "24px",
                            height: "24px",
                            fontSize: "12px",
                            position: "relative",
                          }}
                        >
                          {employee?.firstname &&
                            `${employee?.firstname?.[0]}${employee?.firstname?.[1]}`}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }}
      </Droppable>
      {[...task?.assignees, ...task?.teamassignees]?.map((employee, index) => {
        return (
          <SingleAlert
            employee={employee}
            key={index}
            task={task}
            indexNumber={index + 1}
          />
        );
      })}
      {hover &&
        task?.display === "flex" &&
        [...task?.assignees, ...task?.teamassignees]?.length > 0 && (
          <div
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            className="hover-assignee-list"
            style={{
              left: `${+task?.left?.split("%")[0]?.split(".")[0] + 4}%`,
              zIndex: 10,
            }}
          >
            {[...task?.assignees, ...task?.teamassignees]?.map(
              (employee, i2) => {
                return (
                  <div className="single-hover-assignee" key={i2}>
                    {employee?.imageurl ? (
                      <img
                        alt=""
                        className="task-line-assignees"
                        style={{ marginLeft: "0", borderColor: "#00246a" }}
                        src={employee?.imageurl}
                      />
                    ) : (
                      <div
                        className="team-member-abv"
                        style={{ width: "28px", height: "28px" }}
                      >
                        {employee?.firstname &&
                          `${employee?.firstname[0]}${employee?.firstname[1]}`}
                      </div>
                    )}
                    <p className="med-14-2b1">{employee?.firstname}</p>
                  </div>
                );
              }
            )}
          </div>
        )}
    </div>
  );
};

export default SingleTask;
